/**
 * What the screen says for each way an undo-request call can be refused.
 *
 * Picked by `error_code`, never forwarded from the server's `message`: the
 * words a recruiter or a manager reads are written for them, and they should
 * read the same on every screen that can hit the same refusal.
 */
const MESSAGES = {
  UNDO_REQUEST_ALREADY_PENDING: "An undo request is already awaiting approval for this candidate.",
  UNDO_REQUEST_NOT_PENDING: "This request has already been decided or withdrawn.",
  UNDO_REQUEST_STALE: "The candidate has changed since this request was raised, so it can no longer be applied.",
  UNDO_TARGET_UNAVAILABLE: "The stage this would return to is no longer available, so the request was closed.",
  UNDO_SELF_REVIEW: "You can't review your own request.",
  UNDO_NOT_APPROVER: "This request isn't assigned to you.",
  UNDO_NOT_REQUESTER: "Only the person who raised this request can cancel it.",
  UNDO_REQUEST_NOT_FOUND: "This undo request could not be found.",
  UNDO_REOPEN_BLOCKED_JOB_CLOSED: "This job is closed. Reopen the job before reopening a rejected candidate.",
  STATUS_NOT_TERMINAL: "This candidate can be undone directly. Refresh the page.",
  STATUS_LOCKED_PENDING_UNDO: "Status changes are locked while an undo request is awaiting approval.",
  UNDO_REQUIRES_APPROVAL: "Reopening a Hired or Rejected candidate needs approval. Submit an undo request.",
  NO_STATUS_HISTORY_TO_UNDO: "There is no earlier status to return this candidate to.",
  COMPLIANCE_GATE_BLOCKED: "Compliance checks for this candidate are not complete, so they cannot be reopened to this stage yet.",
  NO_POSITIONS_AVAILABLE: "This job has no open positions left for this stage.",
};

export const undoRequestErrorMessage = (error, fallback) => MESSAGES[error?.response?.data?.error_code] ?? fallback;
